import React, { useEffect, useContext, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Alert } from 'react-bootstrap';
import Cookies from 'js-cookie';

import {
  onDoClear,
  onDoRequestHomePortfolio,
  onDoRequestHomePortfolioStock,
  onDoRequestHomePortfolioBonus,
  onDoRequestHomePortfolioMf,
  onDoRequestHomePortfolioFinancialPlan,
  onDoRequestResetPassword,
} from 'Redux/profile';
import useReferralBonusInfo from '@services/referral/useReferralBonusInfo';
import useBonusSummary from '@services/referral/useBonusSummary';
import { onSetIsInfluencerBannerHidden } from 'Redux/auth';

import { genericStorage } from '@ajaibid/utils';
import { COOKIE_KEY } from '@config/constanta';

import { AuthContext } from '@context/auth';
import { useLoginPin } from '@hooks/auth';
import usePasswordReminder from '@hooks/usePasswordReminder';
import { useOrderAffiliate } from '@hooks/__deprecated__/useOrderAffiliate'; // TODO: remove order affiliate logic
import { useUserData } from '@services/users/me';

import DashboardInvestmentSummary from './DashboardInvestmentSummary';
import DashboardStock from './DashboardStock';
import DashboardMutualFund from './DashboardMutualFund';
import DashboardNews from './DashboardNews';
import PasswordReminder from './PasswordReminder';

import { styDashboardWrapper } from './style';
import useEventTracker from './tracker';

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userData } = useUserData();
  const { isUserNotOnThePinScreen } = useLoginPin();
  const { fetchCheckPassword, isPasswordChange } = usePasswordReminder();

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isOpenVerification, setIsOpenVerification] = useState(false);
  const successResendEmail = useSelector((state) => state.auth.successResendEmail);
  const isInfluencerBannerHidden = useSelector((state) => state.auth.isInfluencerBannerHidden);
  const { coinStatus } = useContext(AuthContext);
  const { isCoinInprogress } = coinStatus;
  const homeData = useSelector((state) => state.auth.homeData);
  const isPasswordChangeStorage = genericStorage.get('is_password_change');
  const hidePasswordChange = () => genericStorage.set('is_password_change', false);

  const { eventVisitHomepage } = useEventTracker();

  const { isOrderAffiliateAvailable, emitten: orderAffiliateEmitten } = useOrderAffiliate();
  const checkAffiliateQueryParams = () => {
    if (isOrderAffiliateAvailable) {
      navigate(`/home/saham/${orderAffiliateEmitten}`);
    }
  };

  useEffect(() => {
    checkAffiliateQueryParams();
  }, []);

  // Check if device is suspended and redirect to /suspended
  useEffect(() => {
    const isDeviceSuspended = Cookies.get(COOKIE_KEY.is_device_suspended);
    if (isDeviceSuspended === 'true') {
      navigate('/suspended');
    }
  }, [navigate]);

  useEffect(() => {
    eventVisitHomepage();

    if (isPasswordChangeStorage === null) {
      fetchCheckPassword();
    }
  }, []);

  useEffect(() => {
    setIsOpenModal(isPasswordChange);
  }, [isPasswordChange]);

  useEffect(() => {
    const hideInfluencerBanner = genericStorage.get('hide_influencer_banner');
    dispatch(onSetIsInfluencerBannerHidden(hideInfluencerBanner));
  }, [isInfluencerBannerHidden]);

  useEffect(() => {
    if (userData && userData.user_info) {
      if (isUserNotOnThePinScreen) {
        dispatch(onDoRequestHomePortfolio());
        dispatch(onDoRequestHomePortfolioStock());
        dispatch(onDoRequestHomePortfolioBonus());
        dispatch(onDoRequestHomePortfolioMf());
        dispatch(onDoRequestHomePortfolioFinancialPlan());
      }
    }
  }, [userData]);

  // Prefetch referral bonus data once via React-Query (cached for 5 min)
  useReferralBonusInfo();
  useBonusSummary();

  const handleNextClose = () => {
    setIsOpenModal(false);
    hidePasswordChange();
  };

  const handleUpdateEmail = () => {
    setIsOpenModal(false);
    setIsOpenVerification(true);
    hidePasswordChange();
    dispatch(onDoRequestResetPassword({ email: homeData.email }));
  };

  const handleOpenVerification = () => {
    dispatch(onDoClear());
    setIsOpenVerification(false);
  };

  return (
    <Col className="p-0">
      <PasswordReminder
        isOpenModal={isOpenModal}
        isOpenVerification={isOpenVerification}
        handleNextClose={handleNextClose}
        handleUpdateEmail={handleUpdateEmail}
        handleOpenVerification={handleOpenVerification}
      />
      <Row noGutters>
        <Col>
          <DashboardInvestmentSummary isCoinInprogress={isCoinInprogress} />
        </Col>
      </Row>
      <Col className={`main-container ${styDashboardWrapper}`} style={{ paddingBottom: 100 }}>
        {successResendEmail && (
          <Row noGutters>
            <Col>
              <Alert variant="primary">Email verifikasi telah dikirim.</Alert>
            </Col>
          </Row>
        )}

        <Row noGutters>
          <Col md={6} className="pr-20">
            <DashboardStock />
          </Col>
          <Col md={6} className="pl-20">
            <DashboardMutualFund />
          </Col>
        </Row>
        <Row noGutters className="mt-40 mb-40">
          <Col md={6} className="pr-20">
            <DashboardNews />
          </Col>
        </Row>
      </Col>
    </Col>
  );
};

export default Dashboard;
